import React, { useEffect, createRef, useState, useMemo } from 'react'
import Toggle from '../../../components/common/toggle'
import { useGeolocated } from 'react-geolocated';
import { MapContainer, TileLayer, Popup, Marker, ZoomControl, useMapEvents, Polygon } from 'react-leaflet';
import L from 'leaflet';
import Image from '../../../components/common/Image';
import { GetInfoByAddressOrXY, GetPlaceAutocomplete } from '../../../api/map8';
import Loading from '../../../components/common/loading'

const Coordinate = ({ data, onChange, parameters, onBack }) => {
    const markerIcon = new L.Icon({
        iconUrl: `${process.env.REACT_APP_BASE_URL}/images/map/marker.png`,
    })
    const MapRef = createRef()
    const [currentCoords, setCurrentCoords] = useState(null);
    const [markerCoord, setMarkerCoord] = useState(null);
    const { coords, isGeolocationAvailable, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: true,
            },
            userDecisionTimeout: 10000,
        });
    useEffect(() => {
        if (data?.position) {
            setCurrentCoords({
                latitude: data.position.lat,
                longitude: data.position.lng,
            })
        } else {
            if (coords && isGeolocationEnabled) {
                setCurrentCoords(coords);
            }else{
                if(!isGeolocationEnabled){
                    //  25.05184344744797, 121.55428011244616
                    // setCurrentCoords(null)
                    setCurrentCoords({
                        latitude: 25.05184344744797, // Default to Taipei
                        longitude: 121.55428011244616,
                    })
                    // console.log("Geolocation is not enabled or available.");
                    // GetPlaceAutocomplete({keyword:'臺北市'}).then(res=>{
                    //     console.log(res)
                    // })
                }   
            }
        }
    }, [coords, isGeolocationEnabled, data]);

    const EventHandle = () => {
        const map = useMapEvents({
            dragend: (e) => {
                const { lat, lng } = e.target.getCenter();
                setMarkerCoord([lat, lng])
            }
        });
        return null;
    }

    return (
        <>
            {
                currentCoords ? (<>
                    <button className='btn-circle back-btn'
                        onClick={onBack}
                    >
                        <Image src='/images/icons/arrow_left.svg' />
                    </button>
                    <div className='coordinate'>

                        <div className='map' id='map'>

                            <MapContainer
                                ref={MapRef}
                                center={[currentCoords.latitude, currentCoords.longitude]}
                                zoom={18}
                                zoomControl={false}
                                scrollWheelZoom={false}
                            >
                                <EventHandle />
                                <TileLayer
                                    url="https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}"
                                    maxNativeZoom={20}
                                    maxZoom={20}
                                // key="normal" // force react to re-render TileLayer
                                />
                                <Marker
                                    icon={markerIcon}
                                    position={markerCoord ? markerCoord : [currentCoords.latitude, currentCoords.longitude]}>
                                </Marker>
                            </MapContainer>

                        </div>
                        <div className="bottom">
                            <div className='btn-block'>
                                <button className='btn-circle' onClick={() => {
                                    MapRef.current.panTo({ lat: currentCoords.latitude, lng: currentCoords.longitude })
                                    setMarkerCoord(null)
                                }}>
                                    <Image src='/images/icons/relocate.svg' />
                                </button>
                            </div>
                            <div className='bottom-block'>
                                <div className='title'>
                                    <p className='font-heading'>設定你的所在位置</p>
                                    <p className='text'>拖曳地圖以移動位置，並選擇位置類型</p>
                                </div>
                                {
                                    parameters && (<Toggle
                                        label='車輛所在的位置是？'
                                        defaultValue={data?.position}
                                        list={parameters.LocationType.data}
                                        onChange={async (data) => {
                                            let obj = {
                                                lat: markerCoord ? markerCoord[0] : currentCoords.latitude,
                                                lng: markerCoord ? markerCoord[1] : currentCoords.longitude,
                                            }
                                            let res = await GetInfoByAddressOrXY(obj)
                                            if (res?.statusCode === 200) {
                                                obj.address = isGeolocationEnabled?res.result[0]["formattedAddress"]:''
                                                obj.city = {
                                                    name: res.result[0]['city'].replaceAll("台", "臺")
                                                }
                                                obj.town = {
                                                    name: res.result[0]['town'].replaceAll("台", "臺")
                                                }
                                            }
                                            onChange({ ...obj, ...data })
                                        }}
                                    />)}
                            </div>
                        </div>
                    </div>
                </>) : (<div className='container'>
                    <Loading/>
                </div>)
            }
        </>)


}

export default Coordinate